module.exports = __webpack_public_path__ + "media/images/home/logo-b5ea7c4d44fdc7d7248ef85f5f09bdbc.svg";